import { LanguageCodeEnum } from '@systemeio/ui'
import i18next from 'i18next'
import { LocalizeValues } from 'shared/hooks/use-loco-translation'
import { addI18nResourceBundle } from 'shared/utils/i18n-resources'

export const addLanguageResource = async (
  languageCode: LanguageCodeEnum,
  ns: LocalizeValues,
  i18nLocal: NonNullable<typeof i18next>,
) => {
  const additionalTranslations = await import(
    `../../../../../public/locales/${languageCode}/${ns}.json`
  )
  addI18nResourceBundle(i18nLocal, languageCode, ns, additionalTranslations)
}
